export default __webpack_public_path__ + "static/akitabox_w.0c2b5c908536b4f84d3d6ee7aea4dccf.png";